module.exports = __webpack_public_path__ + "static/media/challenge-text.56d0a1b4.svg";